        $(document).ready(function() {
                 
          $('body').on('click','a[href="#maintenance"]',function(e) {
                 e.preventDefault();
                 var text = 'Maintenance Plan';
                $('.popup-overlay[popup-text="' + text + '"]').addClass('active');
                $('body, html').css('overflow-y', 'hidden');
               });
                                $('body').on('click', 'a[href="#virtual-pop"]', function(e) {
                        e.preventDefault();
                var text = 'Virtual Stylist';
                $('.popup-overlay[popup-text="' + text + '"]').addClass('active');
                $('body, html').css('overflow-y', 'hidden');
            });
                      $('body').on('click', '.klarna-button', function(e) {
                        e.preventDefault();
                var text = 'Afterpay';
                        if ( $('.popup-overlay[popup-text="' + text + '"]').length > 0) {
                $('.popup-overlay[popup-text="' + text + '"]').addClass('active');
                $('body, html').css('overflow-y', 'hidden');
                        }
            });
            $('body').on('click', '.multicolumn-v5 .multicolumn-list__item', function() {
                var text = $(this).text().trim();
                console.log('clicked this text ' + text);
                if ( $('.popup-overlay[popup-text="' + text + '"]').length > 0) {
                $('.popup-overlay[popup-text="' + text + '"]').addClass('active');
                $('body, html').css('overflow-y', 'hidden');
                }
            });

            $('body').on('click', '#popupClose, #popUpCloseButton', function() {
                $(this).closest('.popup-overlay').removeClass('active');
                $('body, html').css('overflow-y', 'auto');
            });
          $('body').on('click','div[popup-text="Virtual Stylist"] a',function() {
            $(this).closest('.popup-overlay').removeClass('active');
             $('body, html').css('overflow-y', 'auto');
          });

          function openAuthorsie(text){
                        var popup = document.querySelector('.popup-overlay[popup-text="' + text + '"]');
                        if (popup) {
                        popup.classList.add('active');
                        document.body.style.overflowY = 'hidden';
                        document.documentElement.style.overflowY = 'hidden';
                        }
          }


                


                document.querySelectorAll(".AuthorizedDealer").forEach(function(a){
                        a.addEventListener("click", function(){
                                var item = document.querySelectorAll(".multicolumn-v5 .multicolumn-list__item")[3];
                                var text = item.textContent.trim();
                                openAuthorsie(text)
                        })
                })

        });

